import axios from 'axios';

interface AuthStatus {
  isAuthorized: boolean;
  email?: string;
}

interface AuthUrlResponse {
  authUrl: string;
}

const emailService = {
  getAuthStatus: async (): Promise<AuthStatus> => {
    const response = await axios.get<AuthStatus>('/api/email-auth/status');
    return response.data;
  },

  getAuthUrl: async (): Promise<string> => {
    try {
      const response = await axios.get<AuthUrlResponse>('/api/email-auth/auth');
      return response.data.authUrl;
    } catch (error) {
      console.error('Failed to get email auth URL:', error);
      throw error;
    }
  },

  revokeAuthorization: async (): Promise<void> => {
    await axios.post('/api/email-auth/revoke');
  }
};

export default emailService; 